import { render, staticRenderFns } from "./bookmark-list-dialog.vue?vue&type=template&id=32ef977c&"
import script from "./bookmark-list-dialog.vue?vue&type=script&lang=ts&"
export * from "./bookmark-list-dialog.vue?vue&type=script&lang=ts&"
import style0 from "./bookmark-list-dialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports